import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsScimScimDestroyCacheKeys: AllRouteEndpoints[] = ["/integrations/scim/scim_info"];
